import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import urlPatterns from "../../../urls";
import { Container } from "../Container";
import { BackButtonText, BackButtonLink, BreadCrumbDiv } from "./style";

class BreadCrumbBar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      hideBreadCrumbNavigation,
      homeLabel,
      parentLabel,
      parentUrl,
      childLabel,
      childUrl,
      grandChildLabel,
      location,
    } = this.props;

    const { search } = location || {};

    return (
      <BreadCrumbDiv hideBreadCrumbNavigation={hideBreadCrumbNavigation}>
        <Container>
          <p>
            <BackButtonLink to={{ pathname: urlPatterns.GUIDE_101, search }}>{`${homeLabel}`}</BackButtonLink>
            <BackButtonText>{">"}</BackButtonText>
            {parentUrl ? (
              <BackButtonLink to={{ pathname: parentUrl, search }}>{`${parentLabel}`}</BackButtonLink>
            ) : (
              <BackButtonText>{`${parentLabel}`}</BackButtonText>
            )}

            {childLabel && (
              <>
                <BackButtonText>{">"}</BackButtonText>
                {childUrl ? (
                  <BackButtonLink to={{ pathname: childUrl, search }}>{`${childLabel}`}</BackButtonLink>
                ) : (
                  <BackButtonText>{`${childLabel}`}</BackButtonText>
                )}
              </>
            )}

            {grandChildLabel && (
              <>
                <BackButtonText>{">"}</BackButtonText>
                <BackButtonText>{`${grandChildLabel}`}</BackButtonText>
              </>
            )}
          </p>
        </Container>
      </BreadCrumbDiv>
    );
  }
}

BreadCrumbBar.propTypes = {
  hideBreadCrumbNavigation: PropTypes.bool,
  homeLabel: PropTypes.string,
  parentLabel: PropTypes.string,
  parentUrl: PropTypes.string.isRequired,
  childLabel: PropTypes.string,
  childUrl: PropTypes.string,
  grandChildLabel: PropTypes.string,
  location: PropTypes.shape({}).isRequired,
};

BreadCrumbBar.defaultProps = {
  hideBreadCrumbNavigation: false,
  homeLabel: null,
  parentLabel: null,
  childLabel: null,
  childUrl: null,
  grandChildLabel: null,
};

export default BreadCrumbBar;
